"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditGroup = exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var lightAdminActions = require("@caddigital/sok-reducers/lib/actions/project/lightAdmin");
var projectMembersActions = require("@caddigital/sok-reducers/lib/actions/project/members");
var sok_types_1 = require("@caddigital/sok-types");
require("./index.scss");
var CopyUserProfilePermissionMenuItems_1 = require("./CopyUserProfilePermissionMenuItems");
var DatePicker_1 = require("components/DatePicker");
var LightAdminModal_1 = require("./modals/LightAdminModal");
var CreateGroup_1 = require("./CreateGroup");
var mapStateToProps = function (state) {
    return {
        createEdit: state.project.members.createEditModal,
        groups: state.project.members.groups
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(projectMembersActions.toggleModal()); },
    updateCategory: function (project, name, description, id) {
        return dispatch(projectMembersActions.updateCategoryRequest(project.id, name, description, id));
    },
    updateProfileProfile: function (project, name, description, id, toCopy, copyOption, period) {
        return dispatch(projectMembersActions.updateUserProfileRequest(project.id, name, description, id, toCopy, copyOption, period));
    },
    udpateTRMVRMeter: function (project, id, name, siteNumber, mvrmeter) {
        return dispatch(projectMembersActions.updateTRMVRMeterRequest(project.id, name, id, mvrmeter
            ? sok_types_1.TRMVRMeter.iTRMVRMeterTypes.MVRMETER
            : sok_types_1.TRMVRMeter.iTRMVRMeterTypes.TRMETER, siteNumber));
    },
    updateWorksiteDiary: function (project, id, name, worksitediarynumber) {
        return dispatch(projectMembersActions.updateWorksiteDiaryRequest(project.id, name, id, worksitediarynumber));
    },
    updateLightAdmin: function (payload) {
        return dispatch(lightAdminActions.editLightAdminRequest({
            projectId: payload.projectId,
            id: payload.id,
            name: payload.name,
            description: payload.description,
            inviteRightsTo: payload.inviteRightsTo
        }));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('name', 'setName', ''), (0, recompose_1.withState)('description', 'setDescription', ''), (0, recompose_1.withState)('userProfiles', 'setUserProfiles', []), (0, recompose_1.withState)('copiedUserProfile', 'setCopiedUserProfile', undefined), (0, recompose_1.withState)('selectedCopyOption', 'setSelectedCopyOption', undefined), (0, recompose_1.withState)('validSince', 'setValidSince', null), (0, recompose_1.withState)('validUntil', 'setValidUntil', null), (0, recompose_1.withState)('siteNumber', 'setNumber', ''), (0, recompose_1.withState)('inviteRightsTo', 'setInviteRightsTo', []), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _this = this;
        this.props.setName(this.props.createEdit.name);
        this.props.setDescription(this.props.createEdit.description);
        this.props.setValidSince(this.props.createEdit.validSince === undefined
            ? null
            : this.props.createEdit.validSince);
        this.props.setValidUntil(this.props.createEdit.validUntil === undefined
            ? null
            : this.props.createEdit.validUntil);
        this.props.setNumber(this.props.createEdit.siteNumber === undefined
            ? ''
            : this.props.createEdit.siteNumber);
        if (this.props.createEdit.type === 'USER_PROFILE') {
            this.props.setUserProfiles(this.props.groups.reduce(function (acc, c) {
                return c.groups.reduce(function (ac, g) {
                    ac.push(g);
                    return ac;
                }, acc);
            }, []));
        }
        if (this.props.createEdit.type === 'LIGHT_ADMIN') {
            var resolvedInvitableGroups = this.props.groups.reduce(function (resolvedGroups, category) {
                var matchedGroups = category.groups.filter(function (group) {
                    return (_this.props.createEdit.inviteRightsTo || []).includes(group.id);
                });
                return __spreadArray(__spreadArray([], resolvedGroups, true), matchedGroups, true);
            }, []);
            this.props.setInviteRightsTo(resolvedInvitableGroups);
        }
    },
    shouldComponentUpdate: function (prevProps) {
        if (this.props.createEdit.status !== prevProps.createEdit.status ||
            this.props.createEdit.status === 'EDIT') {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
var classes = {
    NONE: '',
    CATEGORY: 'project-members-modal-edit-category',
    SOKOBID: 'project-members-modal-edit-briefcase',
    USER_PROFILE: 'project-members-modal-edit-user-profile',
    TRMETER: 'project-members-modal-edit-trmvrmeter',
    MVRMETER: 'project-members-modal-edit-trmvrmeter',
    WORKSITE_DIARY: 'project-members-modal-edit-worksitediary',
    LIGHT_ADMIN: 'project-members-modal-edit-light-admin'
};
var failMessage = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/categoryModificationFailed',
    SOKOBID: 'userfront/project/teamMembers/briefcaseModificationFailed',
    USER_PROFILE: 'userfront/project/teamMembers/userProfileModificationFailed',
    TRMETER: 'userfront/project/teamMembers/trmeterEditFailed',
    MVRMETER: 'userfront/project/teamMembers/trmeterEditFailed',
    WORKSITE_DIARY: 'userfront/project/teamMembers/worksitediaryCreationFailed',
    LIGHT_ADMIN: 'userfront/project/teamMembers/lightAdminGroupCreationFailed'
};
var headerName = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/editCategory',
    SOKOBID: 'userfront/project/teamMembers/editBriefcase',
    USER_PROFILE: 'userfront/project/teamMembers/editUserProfile',
    TRMETER: 'userfront/project/teamMembers/editTRMVRMeter',
    MVRMETER: 'userfront/project/teamMembers/editTRMVRMeter',
    WORKSITE_DIARY: 'userfront/project/teamMembers/editWorksiteDiary',
    LIGHT_ADMIN: 'userfront/project/teamMembers/editLightAdminGroup'
};
var groupName = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/categoryName',
    SOKOBID: 'userfront/project/teamMembers/briefcaseName',
    USER_PROFILE: 'userfront/project/teamMembers/userProfileName',
    TRMETER: 'userfront/project/teamMembers/worksitediaryName',
    MVRMETER: 'userfront/project/teamMembers/worksitediaryName',
    WORKSITE_DIARY: 'userfront/project/teamMembers/worksitediaryName',
    LIGHT_ADMIN: 'userfront/project/teamMembers/lightAdministratorName'
};
var groupDescription = {
    NONE: '',
    CATEGORY: 'userfront/project/teamMembers/categoryDescription',
    SOKOBID: 'userfront/project/teamMembers/briefcaseDescription',
    USER_PROFILE: 'userfront/project/teamMembers/userProfileDescription',
    TRMETER: '',
    MVRMETER: '',
    WORKSITE_DIARY: '',
    LIGHT_ADMIN: 'userfront/project/teamMembers/userProfileDescription'
};
var editPermGroupTypes = [
    'NormalUserGroup',
    'CategoryUserGroup',
    'CustomerCategoryUserGroup',
    'CustomerUserGroup'
];
var headerGroupTypes = [
    'CategoryUserGroup',
    'CustomerCategoryUserGroup'
];
var getErrorMessage = function (key, error) {
    if (error && error.type === 'CONFLICT') {
        if (key === 'TRMETER' || key === 'MVRMETER') {
            return 'userfront/project/teamMembers/trmeterCreationFailed/alreadyExists';
        }
        else if (key === 'WORKSITE_DIARY') {
            return 'userfront/project/teamMembers/worksitediaryCreationFailed/alreadyExists';
        }
    }
    return failMessage[key];
};
var EditGroup = function (props) {
    if (props.createEdit.type === 'LIGHT_ADMIN')
        return React.createElement(LightAdminModal_1.LightAdminModal, __assign({ onSave: props.updateLightAdmin }, props));
    else
        return (React.createElement(sok_ui_1.Modal, { isOpen: props.createEdit.status === 'EDIT', className: classes[props.createEdit.type] },
            React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)(headerName[props.createEdit.type])),
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                    if (props.createEdit.type === 'CATEGORY') {
                        props.updateCategory(props.currentProject, props.name.trim(), props.description.trim(), props.createEdit.id);
                    }
                    else if (props.createEdit.type === 'SOKOBID' ||
                        props.createEdit.type === 'USER_PROFILE') {
                        props.updateProfileProfile(props.currentProject, props.name.trim(), props.description.trim(), props.createEdit.id, props.copiedUserProfile && props.copiedUserProfile.id, props.copiedUserProfile && props.selectedCopyOption, { validSince: props.validSince, validUntil: props.validUntil });
                    }
                    else if (props.createEdit.type === 'TRMETER' ||
                        props.createEdit.type === 'MVRMETER') {
                        props.udpateTRMVRMeter(props.currentProject, props.createEdit.id, props.name.trim(), props.siteNumber, props.createEdit.type === 'MVRMETER');
                    }
                    else if (props.createEdit.type === 'WORKSITE_DIARY') {
                        props.updateWorksiteDiary(props.currentProject, props.createEdit.id, props.name.trim(), props.siteNumber);
                    }
                } },
                React.createElement(sok_ui_1.Container, null,
                    React.createElement("div", { className: 'content' },
                        React.createElement(sok_ui_1.Row, null,
                            React.createElement(sok_ui_1.Column, null,
                                React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)(groupName[props.createEdit.type])),
                                React.createElement(sok_ui_1.TextInput, { id: 'groupname', value: props.name, className: 'white', placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/categoryName'), onChange: function (e) {
                                        return props.setName(e.target.value.toString());
                                    }, autoFocus: true }),
                                (props.createEdit.type === 'CATEGORY' ||
                                    props.createEdit.type === 'USER_PROFILE' ||
                                    props.createEdit.type === 'SOKOBID') && (React.createElement(sok_ui_1.Column, null,
                                    React.createElement("label", { htmlFor: 'groupdescription' }, (0, translation_1.getLocalization)(groupDescription[props.createEdit.type])),
                                    React.createElement(sok_ui_1.TextInput, { id: 'groupdescription', value: props.description, placeholder: (0, translation_1.getLocalization)(groupDescription[props.createEdit.type]), onChange: function (e) {
                                            return props.setDescription(e.target.value.toString());
                                        }, autoFocus: true })))),
                            props.createEdit.type === 'USER_PROFILE' && (React.createElement(React.Fragment, null,
                                React.createElement(sok_ui_1.Column, null,
                                    React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfilePermissionsToCopy')),
                                    React.createElement(sok_ui_1.Dropdown2, { alignment: 'left', className: 'drop-down-selection', disabled: !props.userProfiles || props.userProfiles.length === 0 },
                                        React.createElement(sok_ui_1.TextInput, { id: 'grouptype', editable: false, className: 'white', value: props.copiedUserProfile
                                                ? props.copiedUserProfile.name
                                                : (0, translation_1.getLocalization)(!props.userProfiles ||
                                                    props.userProfiles.length === 0
                                                    ? 'userfront/project/teamMembers/noUserProfiles'
                                                    : 'userfront/project/teamMembers/selectUserProfile'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-caret-down' }) }),
                                        React.createElement(sok_ui_1.Dropdown2Menu, { key: 'categoryMenu', className: 'project-members-modal-create-user-profile-dropdown' },
                                            React.createElement(CopyUserProfilePermissionMenuItems_1.CopyUserProfilePermissionMenuItems, { groups: props.groups, filterGroupsWithId: [props.createEdit.id], includeCategoryTypes: editPermGroupTypes, disableCategoryTypes: headerGroupTypes, setCopiedUserProfile: props.setCopiedUserProfile })))),
                                React.createElement(sok_ui_1.Column, { className: 'copy-options' },
                                    React.createElement(sok_ui_1.Input, { type: 'radio', name: 'selected', disabled: !props.copiedUserProfile, value: props.selectedCopyOption === 'REPLACE', label: (0, translation_1.getLocalization)('userFront/project/teamMembers/replacePermissions'), onClick: function () { return props.setSelectedCopyOption('REPLACE'); } })),
                                React.createElement(sok_ui_1.Column, { className: 'copy-options' },
                                    React.createElement(sok_ui_1.Input, { type: 'radio', name: 'selected', disabled: !props.copiedUserProfile, value: props.selectedCopyOption === 'APPEND', label: (0, translation_1.getLocalization)('userfront/project/teamMembers/appendPermissions'), onClick: function () { return props.setSelectedCopyOption('APPEND'); } })),
                                React.createElement(sok_ui_1.Column, null,
                                    React.createElement("label", { htmlFor: 'date-picker' }, (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidityPeriod'))),
                                React.createElement(sok_ui_1.Column, { large: 6, medium: 6, extraSmall: 6, className: 'date-input' },
                                    React.createElement(DatePicker_1.DatePicker, { timeCaption: (0, translation_1.getLocalization)('datePicker/time'), showTimeSelect: true, placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidSince'), selected: props.validSince &&
                                            moment(props.validSince, 'L HH:mm'), onChange: function (m, e) {
                                            if (e) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                            }
                                            props.setValidSince(m);
                                        }, selectsStart: true, maxDate: props.validUntil || undefined, dateFormat: "L HH:mm" })),
                                React.createElement(sok_ui_1.Column, { large: 6, medium: 6, extraSmall: 6, className: 'date-input' },
                                    React.createElement(DatePicker_1.DatePicker, { timeCaption: (0, translation_1.getLocalization)('datePicker/time'), showTimeSelect: true, placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/userProfileValidUntil'), className: 'date-input', selected: props.validUntil &&
                                            moment(props.validUntil, 'L HH:mm'), onChange: function (m, e) {
                                            if (e) {
                                                e.stopPropagation();
                                                e.preventDefault();
                                            }
                                            props.setValidUntil(m);
                                        }, selectsEnd: true, dateFormat: "L HH:mm" })))),
                            (props.createEdit.type === 'MVRMETER' ||
                                props.createEdit.type === 'TRMETER' ||
                                props.createEdit.type === 'WORKSITE_DIARY') && (React.createElement(sok_ui_1.Column, null,
                                React.createElement("label", { htmlFor: 'worksitediarynumber' }, (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryNumber')),
                                React.createElement(sok_ui_1.TextInput, { type: 'text', inputMode: 'text', min: "1", id: 'worksitediarynumber', value: props.siteNumber || '', placeholder: (0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryNumber'), onKeyPress: CreateGroup_1.validateSiteNumberInput, onChange: function (e) {
                                        return props.setNumber(e.target.value);
                                    } }))),
                            props.createEdit.isSaving === 'FAILED' && (React.createElement(sok_ui_1.Column, null,
                                React.createElement("span", { className: 'request-failed' }, (0, translation_1.getLocalization)(getErrorMessage(props.createEdit.type, props.createEdit.error)))))))),
                React.createElement(sok_ui_1.Footer, null,
                    React.createElement(sok_ui_1.Button, { disabled: props.createEdit.isSaving === 'SAVING' ||
                            props.name.trim().length === 0, text: (0, translation_1.getLocalization)('userfront/project/teamMembers/save'), color: 'base-green', type: 'submit' }),
                    React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/project/teamMembers/cancel'), color: 'dark-gray', onClick: props.toggleModal })))));
};
exports.EditGroup = EditGroup;
exports.default = enhance(exports.EditGroup);
